import React, { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Droplets } from "lucide-react";

const HydrationCalculator = () => {
  const [weight, setWeight] = useState("");
  const [result, setResult] = useState<number | null>(null);

  const calculateWater = () => {
    const w = parseFloat(weight);
    if (!isNaN(w) && w > 0) {
      // Basic formula: Weight (kg) * 0.033 = Liters
      // Or Weight (lbs) / 2.2 * 0.033
      // Assuming input is in kg for simplicity, or we can add a toggle.
      // Let's assume kg as it's standard in many places, or clarify.
      // Let's just use a generic "35ml per kg" rule.
      const liters = w * 0.035;
      setResult(liters);
    }
  };

  return (
    <Card className="h-full bg-white/40 backdrop-blur-md border-white/20 shadow-sm hover:shadow-md transition-all duration-300">
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center gap-2 text-lg">
          <Droplets className="w-5 h-5 text-primary" />
          Hydration Calculator
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-4 space-y-4">
        {!result ? (
          <div className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="weight">Weight (kg)</Label>
              <Input
                id="weight"
                type="number"
                placeholder="Enter your weight"
                value={weight}
                onChange={(e) => setWeight(e.target.value)}
              />
            </div>
            <Button onClick={calculateWater} className="w-full">
              Calculate
            </Button>
          </div>
        ) : (
          <div className="text-center space-y-4 py-2">
            <p className="text-muted-foreground">Recommended daily intake:</p>
            <p className="text-3xl font-bold text-primary">
              {result.toFixed(1)} Liters
            </p>
            <p className="text-sm text-muted-foreground">
              (~{Math.round(result * 4)} glasses)
            </p>
            <Button
              variant="outline"
              onClick={() => setResult(null)}
              className="w-full"
            >
              Recalculate
            </Button>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default HydrationCalculator;
